import { useContext, createContext, useState } from 'react';

const OverlayContext = createContext();

export function useOverlay() {
  return useContext(OverlayContext);
}

function OverlayProvider({ children }) {
  const [overlay, setOverlay] = useState(null);
  
  return (
    <OverlayContext.Provider value={{overlay, setOverlay}}>
      {children}
    </OverlayContext.Provider>
  );
}

export default OverlayProvider;